import React, { useState, useEffect, createContext } from 'react'
import axios from 'axios'
import { omit } from 'lodash'
import moment from 'moment'
import { redirectToAuthWithFrom } from './UserContext'

export const BookingContext = createContext()

const FieldsToExclude = ['created_at', 'updated_at', 'user_id']

const RemapFromBack = {
  start_date: (values) => (values.start_date ? moment(values.start_date) : null),
  end_date: (values) => (values.end_date ? moment(values.end_date) : null),
  over12Months: (values) => (!moment(values.end_date, 'DD-MM-YYYY').isValid() ? null : values.end_date ? 'under' : 'over'),
}

const MappingToBack = async (booking) => {
  const fieldsFiltered = omit(booking, FieldsToExclude)
  const remappedValues = {}
  for (let i in RemapFromBack) {
    let remap = RemapFromBack[i]
    remappedValues[i] = remap(fieldsFiltered)
  }
  const objectBooking = {
    ...fieldsFiltered,
    ...remappedValues,
  }
  return objectBooking
}

export const BookingProvider = (props) => {
  const [booking, setBooking] = useState(undefined)
  const [isLoading, setIsLoading] = useState(true)
  const [hasCounteroffer, setHasCounteroffer] = useState(false)
  const [counterofferAccepted, setCounterofferAccepted] = useState(null)

  useEffect(() => {
    const getBooking = async () => {
      try {
        const { data: res } = await axios.get(`${process.env.REACT_APP_BOOKING_API}/${props.id}`)
        const booking = await MappingToBack(res)
        setIsLoading(false)
        setBooking(booking)
      } catch (e) {
        if (e.response.status === 401) {
          redirectToAuthWithFrom()
        }
        setBooking(true)
        setIsLoading(false)
      }
    }
    getBooking()
  }, [])
  return (
    <BookingContext.Provider
      value={{
        booking,
        isLoading,
        hasCounteroffer,
        setHasCounteroffer,
        counterofferAccepted,
        setCounterofferAccepted,
      }}
    >
      {props.children}
    </BookingContext.Provider>
  )
}
